/** Herkenbare sleutel per e-mailveld op een contactkaart. */
export type ContactEmailOptionKey = "dominicus" | "primair" | "secundair";

export type ContactEmailOption = {
  key: ContactEmailOptionKey;
  label: string;
  email: string;
};

function isValidEmail(raw: string | null | undefined): boolean {
  return (raw ?? "").trim().includes("@");
}

/**
 * Alle verschillende e-mailadressen op een kaart (Dominicus, primair, secundair),
 * in vaste volgorde, zonder dubbele adressen (hoofdletterongevoelig).
 */
export function contactEmailOptions(c: {
  email?: string;
  email_prive?: string;
  email_werk?: string;
  dominicus_email?: string | null;
}): ContactEmailOption[] {
  const options: ContactEmailOption[] = [];
  const seen = new Set<string>();

  const add = (key: ContactEmailOptionKey, label: string, raw: string | null | undefined) => {
    const email = (raw ?? "").trim();
    if (!isValidEmail(email)) return;
    const lower = email.toLowerCase();
    if (seen.has(lower)) return;
    seen.add(lower);
    options.push({ key, label, email });
  };

  add("dominicus", "E-mail Dominicus", c.dominicus_email);
  const primair = (c.email_prive || c.email || "").trim();
  add("primair", "E-mail (primair)", primair || undefined);
  add("secundair", "E-mail (secundair)", c.email_werk);

  return options;
}
